import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from "../context/LanguageContext";
import { useTheme } from "../context/ThemeContext";
import { caseStudies } from '../data/caseStudies';
import { ArrowRight } from "lucide-react";

const CaseStudiesPage = () => {
  const { language } = useLanguage();
  const { theme } = useTheme();

  return (
    <div className={`py-16 px-4 ${theme === "dark" ? "bg-gray-900" : "bg-white"}`}>
      <div className="max-w-7xl mx-auto">
        <h1 className={`text-4xl font-bold mb-12 ${
          theme === "dark"
            ? "bg-gradient-to-r from-green-400 to-green-600 bg-clip-text text-transparent"
            : "text-green-600"
        }`}>
          {language === "en" ? "All Case Studies" : "Toutes les Études de Cas"}
        </h1>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {caseStudies.map((study) => (
            <Link
              key={study.id}
              to={`/case-studies/${study.slug}`}
              className={`group relative overflow-hidden rounded-lg ${
                theme === "dark"
                  ? "bg-gray-900 border border-green-500/20 hover:border-green-500/40"
                  : "bg-gray-100 border border-green-300/20 hover:border-green-400/40"
              } transition-all`}
            >
              <div className="aspect-video overflow-hidden">
                <img
                  src={study.imageUrl}
                  alt={language === "en" ? study.titleEn : study.titleFr}
                  className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <span className={`text-sm font-semibold ${
                  theme === "dark" ? "text-green-500" : "text-green-600"
                }`}>
                  {language === "en" ? study.categoryEn : study.categoryFr}
                </span>
                <h3 className={`text-xl font-semibold mt-2 mb-3 ${
                  theme === "dark" ? "text-white" : "text-gray-900"
                }`}>
                  {language === "en" ? study.titleEn : study.titleFr}
                </h3>
                <p className={`mb-4 ${
                  theme === "dark" ? "text-gray-400" : "text-gray-700"
                }`}>
                  {language === "en" ? study.descEn : study.descFr}
                </p>
                <span className={`flex items-center ${
                  theme === "dark"
                    ? "text-green-500 group-hover:text-green-400"
                    : "text-green-600 group-hover:text-green-500"
                } transition-colors`}>
                  {language === "en" ? "Read More" : "Lire Plus"}
                  <ArrowRight className="w-4 h-4 ml-2" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CaseStudiesPage; 